import * as React from "react";
import {Filter, FilterValue} from "./App";
import {useEffect, useRef} from "react";
interface Props {
	filter: Filter,
	values: Set<FilterValue>,
	onFilterChange?: FilterChangesCallback;
    onToggleFilterBucket: (filterId: string) => void;
}

interface FilterChangesCallback {
	(value: string): void;
}


export default function FilterBucket(props: Props) {
    // const bucketRef = useRef(null);
    // useEffect(() => {
    //
    //     function handleClickOutside(event: any) {
    //         if (bucketRef.current && !bucketRef.current.contains(event.target) && event.target.id !== props.filter.id) {
    //             props.onToggleFilterBucket(props.filter.id);
    //         }
    //     }
    //     // Bind the event listener
    //     document.addEventListener("mousedown", handleClickOutside);
    //     return () => {
    //         // Unbind the event listener on clean up
    //         document.removeEventListener("mousedown", handleClickOutside);
    //     };
    // }, [bucketRef]);

    return (
			<ul className={"filter-bucket"} >
				{Array.from(props.values).map(value => {
					return (
						<li key={value.value}>
							<label>
								<input className="srOnly" type="checkbox" name={"filters["+props.filter.id+"][]"} checked={value.checked} onChange={(event) => props.onFilterChange(value.value)} />
								<span>{value.label} ({value.count})</span>
							</label>
						</li>
					)
				})}
			</ul>
	);
}
